import type { MouseEvent } from 'react';

export const isRowSelectionBlocked = (e: MouseEvent) => {
  const target = e.target as HTMLElement;
  if (
    target.closest('a') ||
    target.closest('button') ||
    target.closest('svg[data-icon="file-search"]') ||
    target.closest('svg[data-icon="more"]') ||
    target.closest('[role="menuitem"]') ||
    target.tagName === 'BUTTON'
  ) {
    return true;
  }
  return false;
};
